(function () {
    if (window.__cardSwatchInit) return;
    window.__cardSwatchInit = true;

    function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

    function getCardData(card) {
        if (card.__variantData) return card.__variantData;
        var node = card.querySelector('script[data-card-variants]');
        if (!node) return null;
        try { card.__variantData = JSON.parse(node.textContent); }
        catch (e) { card.__variantData = null; }
        return card.__variantData;
    }

    function getSelectedColor(card) {
        var sel = card.querySelector('.card-color-swatch.is-selected');
        if (sel) return sel.getAttribute('data-color-value');
        var first = card.querySelector('.card-color-swatch');
        return first ? first.getAttribute('data-color-value') : null;
    }

    function handleizeSize(raw) {
        return (raw == null ? '' : raw.toString()).toLowerCase().replace(/\s+/g, '-');
    }

    function findVariant(card, colorValue, sizeValue) {
        var data = getCardData(card);
        if (!data) return null;
        var colorIdx = parseInt(card.getAttribute('data-color-index'), 10);
        var sizeIdx  = parseInt(card.getAttribute('data-size-index'), 10);

        for (var i = 0; i < data.length; i++) {
            var v = data[i];
            var ok = true;
            if (colorIdx >= 0 && colorValue != null) {
                if (v.options[colorIdx] !== colorValue) ok = false;
            }
            if (ok && sizeIdx >= 0 && sizeValue != null) {
                var raw = v.options[sizeIdx] || '';
                if (handleizeSize(raw) !== sizeValue && raw !== sizeValue) ok = false;
            }
            if (ok) return v;
        }
        return null;
    }

    function setSwiperToMedia(card, mediaId) {
        if (!mediaId) return;
        var slider = card.querySelector('.card-slider');
        if (!slider) return;
        if (!slider.swiper && window.nsInitCard) window.nsInitCard(slider); /* sliders start lazily (script.js) */
        var slides = $all('.swiper-slide', slider);
        var targetIndex = -1;
        for (var i = 0; i < slides.length; i++) {
            if (slides[i].getAttribute('data-media-id') === String(mediaId)) {
                targetIndex = i;
                break;
            }
        }
        if (targetIndex < 0) return;

        if (slider.swiper && typeof slider.swiper.slideToLoop === 'function') {
            try { slider.swiper.slideToLoop(targetIndex, 300, false); return; } catch (e) {}
        }
        if (slider.swiper && typeof slider.swiper.slideTo === 'function') {
            try { slider.swiper.slideTo(targetIndex, 300, false); return; } catch (e) {}
        }
        var wrapper = slider.querySelector('.swiper-wrapper');
        if (wrapper) {
            wrapper.style.transition = 'transform .3s ease';
            wrapper.style.transform = 'translate3d(-' + (targetIndex * 100) + '%, 0, 0)';
        }
    }

    function updatePrice(card, variant) {
        if (!variant) return;
        var priceEl = card.querySelector('[data-card-price]');
        var compareEl = card.querySelector('[data-card-compare-price]');
        /* Notre A/B (8 Oct): a card in a price test keeps its [data-ns-ab] span; the shown price follows the visitor's arm */
        var abSpan = priceEl && priceEl.querySelector('[data-ns-ab]');
        if (abSpan && window.nsAB && window.nsAB.money) {
            abSpan.setAttribute('data-ns-ab-c', variant.price);
            abSpan.textContent = window.nsAB.money(window.nsAB.adj(abSpan.getAttribute('data-ns-ab'), variant.price));
        } else if (priceEl && variant.price_formatted) priceEl.textContent = variant.price_formatted;
        if (compareEl) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                compareEl.textContent = variant.compare_at_price_formatted;
                compareEl.style.display = '';
            } else {
                compareEl.style.display = 'none';
            }
        }
    }

    function updateCardLink(card, variant) {
        if (!variant || !variant.url) return;
        var imgLink = card.querySelector('[data-card-link]');
        var titleLink = card.querySelector('[data-card-title-link]');
        if (imgLink) imgLink.setAttribute('href', variant.url);
        if (titleLink) titleLink.setAttribute('href', variant.url);
    }

    function updateSizeAvailability(card, colorValue) {
        var data = getCardData(card);
        if (!data) return;
        var colorIdx = parseInt(card.getAttribute('data-color-index'), 10);
        var sizeIdx  = parseInt(card.getAttribute('data-size-index'), 10);
        if (sizeIdx < 0) return;

        var availMap = {};
        data.forEach(function (v) {
            if (colorIdx >= 0 && colorValue != null && v.options[colorIdx] !== colorValue) return;
            var raw = v.options[sizeIdx] || '';
            var handle = handleizeSize(raw);
            if (availMap[handle] === undefined || v.available) availMap[handle] = v.available;
        });

        $all('.product-option .product-varient-input', card).forEach(function (input) {
            var label = input.closest('.product-varient-field');
            if (!label) return;
            var val = input.value;
            var available = availMap[val];
            if (available === false) {
                label.classList.add('is-unavailable');
            } else {
                label.classList.remove('is-unavailable');
            }
        });
    }

    // ============== Gift-mode helper ==============
    // On gift cards (.product-card--gift), clicking a color swatch must sync the
    // gift variant select to the first AVAILABLE variant of that color, so the
    // Add Free Gift button adds what the customer sees. (Parity with Olivier,
    // where the swatch drives the gift select.)
    function syncGiftSelect(card, colorValue) {
        if (!card.classList.contains('product-card--gift')) return;
        var gsel = card.querySelector('.gift-variant-select');
        if (!gsel) return;
        var data = getCardData(card) || [];
        var colorIdx = parseInt(card.getAttribute('data-color-index'), 10);
        var pick = null;
        for (var i = 0; i < data.length; i++) {
            var v = data[i];
            if (colorIdx >= 0 && colorValue != null && v.options[colorIdx] !== colorValue) continue;
            if (v.available) { pick = v; break; }
            if (!pick) pick = v;
        }
        if (pick) { gsel.value = String(pick.id); }
    }

    // ============== Click on color swatch ==============
    function onSwatchClick(e) {
        var swatch = e.currentTarget;
        var card = swatch.closest('[data-product-card]');
        if (!card) return;

        e.preventDefault();
        e.stopPropagation();

        $all('.card-color-swatch', card).forEach(function (s) { s.classList.remove('is-selected'); });
        swatch.classList.add('is-selected');

        var colorValue = swatch.getAttribute('data-color-value');
        var mediaId = swatch.getAttribute('data-media-id');

        setSwiperToMedia(card, mediaId);

        // Gift-mode card: keep the gift select in sync with the chosen color
        syncGiftSelect(card, colorValue);

        // Recompute price + url based on currently checked size (or first variant of color)
        var sizeIdx = parseInt(card.getAttribute('data-size-index'), 10);
        var sizeValue = null;
        if (sizeIdx >= 0) {
            var checkedSize = card.querySelector('.product-option .product-varient-input:checked');
            if (checkedSize) sizeValue = checkedSize.value;
        }
        var variant = findVariant(card, colorValue, sizeValue);
        if (!variant) variant = findVariant(card, colorValue, null);

        if (variant) {
            updatePrice(card, variant);
            updateCardLink(card, variant);
        }
        updateSizeAvailability(card, colorValue);
    }

    // ============== Add to cart helper ==============
    function addToCart(card, variant) {
        if (!variant) return;

        // Gift logic — keep parity with the existing flow in script.js
        var tags = (card.getAttribute('data-product-tags') || '').split(',').map(function (t) { return t.trim(); });
        var isGift100 = tags.indexOf('gift-100') !== -1;
        var isGift150 = tags.indexOf('gift-150') !== -1;

        function openDrawer() {
            var cs = document.querySelector('.cart-sidebar');
            if (cs) cs.classList.add('active');
            document.body.classList.add('active');
        }

        // Open the drawer AFTER the item is in the cart and the drawer has been refreshed.
        // cart_drawer_update() is async — await/Promise.resolve handles both async and sync impls.
        function finishAndOpen() {
            try {
                var maybePromise = (typeof cart_drawer_update === 'function') ? cart_drawer_update() : null;
                Promise.resolve(maybePromise).then(openDrawer).catch(openDrawer);
            } catch (e) {
                openDrawer();
            }
        }

        if ((isGift100 || isGift150) && typeof tryAddGift === 'function') {
            // Gift flow handles its own cart update — open drawer once it's done
            tryAddGift(variant.id, isGift100, isGift150, finishAndOpen);
            return;
        }

        // Standard add — use jQuery if available (matches the rest of the theme), else fetch
        if (window.jQuery) {
            window.jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: { id: variant.id, quantity: 1 },
                dataType: 'json',
                success: finishAndOpen,
                error: function (err) { console.log('Add to cart error', err); }
            });
        } else {
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variant.id, quantity: 1 })
            }).then(function (res) {
                if (!res.ok) throw new Error('Add to cart failed');
                finishAndOpen();
            }).catch(function (err) { console.log('Add to cart error', err); });
        }
    }

    // ============== Intercept the size-radio click ==============
    // Capture-phase listener so we run BEFORE the legacy handler in script.js and can stop it.
    function onSizeChangeCapture(e) {
        var input = e.target;
        if (!input || !input.classList || !input.classList.contains('product-varient-input')) return;
        var card = input.closest('[data-product-card]');
        if (!card) return;

        // Intercept for any recognized quick-add card that has a size option —
        // not just cards with a second color option / swatch overlay. Size-only
        // cards (no .card-color-swatches) used to fall through to the legacy,
        // slow, string-matching handler in script.js, which is the source of
        // the sluggish/inconsistent/needs-two-taps quick-add glitch reported on
        // those products. data-size-index is always emitted on quick-add cards
        // (see card-product.liquid), so this is a safe, equivalent guard that
        // also covers color-only cards correctly (findVariant() already treats
        // sizeIdx < 0 as "no size to match", so nothing breaks for those).
        if (!card.hasAttribute('data-product-card')) return;
        var sizeIdxGuard = parseInt(card.getAttribute('data-size-index'), 10);
        if (!(sizeIdxGuard >= 0)) return;

        // Stop the legacy handler from running
        e.stopImmediatePropagation();

        var colorValue = getSelectedColor(card);
        var sizeValue = input.value;
        var variant = findVariant(card, colorValue, sizeValue);

        if (!variant) {
            console.log('No matching variant for', colorValue, sizeValue);
            return;
        }
        if (!variant.available) {
            // Non-blocking feedback: the size is already visually greyed out via
            // .is-unavailable (see updateSizeAvailability above). A native alert()
            // here would freeze all page JS and require a manual dismiss, which is
            // far more disruptive than any network round trip. Instead, briefly
            // flash the label so the shopper gets an immediate, non-blocking cue.
            var soldOutLabel = input.closest('.product-varient-field');
            if (soldOutLabel) {
                soldOutLabel.classList.remove('is-soldout-flash');
                // Force reflow so the animation restarts if clicked again quickly
                void soldOutLabel.offsetWidth;
                soldOutLabel.classList.add('is-soldout-flash');
                setTimeout(function () {
                    soldOutLabel.classList.remove('is-soldout-flash');
                }, 600);
            }
            return;
        }

        updatePrice(card, variant);
        updateCardLink(card, variant);
        addToCart(card, variant);
    }

    function bind() {
        $all('[data-color-swatch]').forEach(function (sw) {
            if (sw.__bound) return;
            sw.__bound = true;
            sw.addEventListener('click', onSwatchClick);
        });
        $all('[data-product-card]').forEach(function (card) {
            if (card.__sizeInit) return;
            card.__sizeInit = true;
            var color = getSelectedColor(card);
            if (color) updateSizeAvailability(card, color);
        });
    }

    // Capture-phase listener — runs before script.js's bubbling handler
    document.addEventListener('change', onSizeChangeCapture, true);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bind);
    } else {
        bind();
    }

    document.addEventListener('shopify:section:load', bind);

    var debounce;
    var mo = new MutationObserver(function () {
        clearTimeout(debounce);
        debounce = setTimeout(bind, 100);
    });
    mo.observe(document.body, { childList: true, subtree: true });
})();
